<template>
  <div id="app">
    <div ref="captureArea" class="captureArea">
      <h2 class="gameTitle" @click="효과음()">COLOR POP GAME</h2>
      <div>유저들이 총 <span class="text-primary">{{ 전체플레이.toLocaleString() }}</span>번 도전했습니다 ({{ 최근도전 }}전)</div>
      <div class="score mb-3">[ Lv.{{ 게임레벨 + 1 }} ] {{ 스코어.toLocaleString() }}점</div>

      <!-- 게임창 -->
      <div class="lifeBox">
        <div class="life"></div>
      </div>
      <div class="row space shadow">
        <div class="col-4" @click="충전중지(i)" v-for="(a, i) in 오픈스페이스" :key="i">
          <div class="guage-box">
            <div class="guage"></div>
            <div class="guage-limit"></div>
          </div>
          <div class="point">{{ 스페이스[i].획득점수 }}</div>
        </div>

        <!-- 시작버튼모달 -->
        <div class="buttomModal" v-if="게임시작전">
          <!-- 게임설명 -->
          <div class="gameRule mt-3">
            <h4>게임방법</h4>
            1. 색이 가이드선까지 차면 터치하기<br />
            <span class="gameRuleMore">(가이드선 근접하면 득점, 반대는 감점)<br /></span>
            2. 한 칸이라도 색이 꽉 차면 게임종료<br />
            3. 생명력이 0 되면 게임종료
          </div>
          <!-- 시작버튼 -->
          <div class="startBtn">
            <button class="btn btn-primary mt-3" @click="게임시작">게임시작</button>
          </div>
        </div>

        <!-- 결과창모달 -->
        <div class="resultModal" v-if="결과창모달">
          <div class="inputBox">
            <div class="mb-3 fw-bold text-primary">
              <span class="resultScore">
                Rank {{ 나의랭크순위 }}<br />
                {{ 스코어.toLocaleString() }}P</span>
            </div>
            <input class="inputName" type="text" v-model="닉네임" placeholder="닉네임 작성">
          </div>
          <div v-if="this.닉네임.length">
            <button class="btn btn-primary mx-2" @click="캡쳐()" v-if="결과창모달">기록캡쳐</button>
            <button class="btn btn-primary mx-2" @click="랭크등록">점수등록</button>
          </div>
          <button type="button" class="btn-close" @click="정말이니"></button>
        </div>
      </div>
      <div class="bottomBlank"></div>
    </div>
    <!-- 랭크리스트 -->
    <div class="rankList" v-if="게임시작전">
      <!-- 보기방식 변경용 투명바 -->
      <div class="fakebar" @click="기록()"></div>

      <!-- 기록순서로 보기 -->
      <table class="table table-hover" v-if="기록순서 == true">
        <thead>
          <tr :class="[관대하다 === true ? 'text-bg-danger' : 'text-bg-primary']">
            <th scope="col" class="fw-normal">랭크</th>
            <th scope="col" class="fw-normal">닉네임</th>
            <th scope="col" class="fw-normal">◀최고점수▶</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(a, i) in 랭크정보" :key="i" >
            <th scope="row">{{a.rank}}</th>
            <td @click="기록제거(a.id)">{{ a.name }}</td>
            <td>{{ a.score.toLocaleString() }}<span class="text-primary"> ({{ ago(a.date) }})</span></td>
          </tr>
        </tbody>
      </table>
      <!-- 최근순서로 보기 -->
      <table class="table table-hover" v-if="기록순서 == false">
        <thead>
          <tr :class="[관대하다 === true ? 'text-bg-danger' : 'text-bg-primary']">
            <th scope="col" class="fw-normal">랭크</th>
            <th scope="col" class="fw-normal">닉네임</th>
            <th scope="col" class="fw-normal">◀최근점수▶</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(a, i) in 랭크정보2" :key="i" >
            <!-- <th scope="row">{{ 랭크정보2.length - i }}</th> -->
            <th scope="row">{{ a.rank }}</th>
            <td @click="기록제거(a.id)">{{ a.name }}</td>
            <td>{{ a.score.toLocaleString() }}<span class="text-primary"> ({{ ago(a.date) }})</span></td>
          </tr>
        </tbody>
      </table>

      <!-- 맨위로 버튼 -->
      <button :class="[관대하다 === true ? 'btn btn-danger' : 'btn btn-primary']" class="goTop" @click="맨위로()">▲</button>
    </div>

  </div>

</template>

<script>

import { db } from './main.js'

//화면캡쳐 파일 //npm install --save html2canvas
import html2canvas from "html2canvas"

export default {
  name: 'App',

  data() {
    return {

      플레이체크아이디: '',
      전체플레이: 0,
      최근도전: 0,

      게임시작전: true,
      오픈스페이스: 9,

      스페이스: [
        { 번호: 1, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 2, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 3, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 4, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 5, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 6, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 7, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 8, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
        { 번호: 9, 게이지: 0, 충전: '', 충전중: false, 등록칼라: 0, 획득점수: '' },
      ],

      칼라: [
        { 색깔: 'red', 충전속도: 80, 요구게이지: 50, 점수: 100 },
        { 색깔: 'orange', 충전속도: 70, 요구게이지: 30, 점수: 110 },
        { 색깔: 'rgb(255, 215, 0)', 충전속도: 60, 요구게이지: 60, 점수: 120 },
        { 색깔: 'green', 충전속도: 50, 요구게이지: 50, 점수: 130 },
        { 색깔: 'blue', 충전속도: 40, 요구게이지: 40, 점수: 140 },
        { 색깔: 'purple', 충전속도: 30, 요구게이지: 70, 점수: 150 },
      ],

      게임난이도: [
        { 레벨: 1, 등장속도: 1000, 기준점수: 500 },
        { 레벨: 2, 등장속도: 900, 기준점수: 1000 },
        { 레벨: 3, 등장속도: 800, 기준점수: 1750 },
        { 레벨: 4, 등장속도: 700, 기준점수: 2750 },
        { 레벨: 5, 등장속도: 600, 기준점수: 4000 },
        { 레벨: 6, 등장속도: 500, 기준점수: 5500 },
        { 레벨: 7, 등장속도: 400, 기준점수: 7250 },
        { 레벨: 8, 등장속도: 300, 기준점수: 9250 },
        { 레벨: 9, 등장속도: 200, 기준점수: 11500 },
        { 레벨: 10, 등장속도: 100, 기준점수: 999999 },
      ],

      게임레벨: 0,
      충전시작루프: '',
      스코어: 0,
      생명력: 50,
      시작시간: 0,
      끝시간: 0,
      배드체커: 0,

      닉네임: '',
      결과창모달: false,
      닉네임체크: false,

      나의랭크순위: 0,
      나의최고점수: 0,

      peekabooCount: 0,
      JSRCODE: '051202',

      랭크정보: [],
      랭크정보2: [],

      기록순서: true,
      관대하다 : false,
    }
  },

  methods: {

    캡쳐() {
      html2canvas(this.$refs.captureArea).then(canvas => {
        var myImage = canvas.toDataURL();
        this.downloadURI(myImage, "ColorPopGameScore.png")
      })
    },

    downloadURI(uri, name) {
      var link = document.createElement("a")
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
    },

    기록() {
      this.기록순서 = !this.기록순서
    },

    맨위로() {
      window.scrollTo(0, 0)

      if(this.관대하다==false){
      this.peekabooCount++
      setTimeout(() => {
        this.peekabooCount = 0
      }, 1200)
      // console.log(this.peekabooCount)
      if (this.peekabooCount == 5) {
        this.peekabooCount = 0
        var pw = prompt('관리자 코드입력')
        if (this.JSRCODE == pw) {
          this.관대하다=true
        }
        else {
          alert('코드 불일치')
        }
      }
    }else{
      this.관대하다=false
    }
      
    },

    효과음() {
      var audio = new Audio(require('@/sound/button-11.wav'));
      audio.volume = 0.5;
      audio.play();
    },

    배드효과음() {
      var audio = new Audio(require('@/sound/bad.wav'));
      audio.volume = 0.2;
      audio.play();
    },

    랭크등록() {

      if (this.닉네임 == '') {
        alert('닉네임 뭐라도 적으쇼')
      }
      else {
        this.랭크정보.forEach((e) => {
  //찾았으면(그 아이디를 가지고 업데이트, 그런데 기존 점수보다 낮으면 업데이트 안 함)
          if (this.닉네임 == e.name) {
            //찾았네? 닉네임체크가 끝까지 false 이면 forEach 끝나고 다른 조건문으로 슝
            this.닉네임체크 = true
            //이제 점수 비교
            //기존 점수보다 낮음
            if (this.스코어 <= e.score) {
              alert('저번 기록 못 넘어서 등록 실패!')
            }
            //기존 점수보다 높음(갱신)
            else {
              let 바꿀거 = {
                rank :this.나의랭크순위,
                date: new Date(),
                name: this.닉네임,
                score: this.스코어,
                playtime: Math.floor(this.끝시간 - this.시작시간),
                bad: this.배드체커
              }
              db.collection('rank').doc(e.id).update(바꿀거).then(() => {
                this.결과창모달 = false
              })
              alert('저번보다 잘함. 기록 업데이트 성공!')
            }
          }
        })

        if (this.닉네임체크 == false) {
          let 등록할거 = {
            rank :this.나의랭크순위,
            date: new Date(),
            name: this.닉네임,
            score: this.스코어,
            playtime: Math.floor(this.끝시간 - this.시작시간),
            bad: this.배드체커
          }
          db.collection('rank').add(등록할거).then(() => {
            this.결과창모달 = false
            alert('처음 왔니? 신규 등록 완료!')
          })
        }

        this.닉네임체크 = false
      }
    },

    정말이니() {
      this.결과창모달 = false
    },

    기록제거(i) {
      if(this.관대하다==true){
          db.collection('rank').doc(i).delete()
      }
    },

    게임시작() {

      this.효과음()
      this.시작시간 = Math.floor(new Date() / 1000)
      this.배드체커 = 0

      this.전체플레이++
      var 플레이카운트업데이트 = {
        all: this.전체플레이,
        date: new Date()
      }
      db.collection('visit').doc(this.플레이체크아이디).update(플레이카운트업데이트)

      this.생명력 = 50

      let 생명력게이지 = document.getElementsByClassName('life')[0]
      생명력게이지.style.width = this.생명력 + '%'
      생명력게이지.style.background = '#0d6efd'

      this.게임시작전 = false
      this.게임레벨 = 0
      this.스코어 = 0
      this.스페이스.forEach((e) => {
        e.획득점수 = ''
      })

      this.충전시작()
    },

    레벨업() {
      if (this.게임레벨 == 11) {
        this.스코어 = 999999
        this.게임오버()
      }
      else if (this.스코어 > this.게임난이도[this.게임레벨].기준점수) {
        clearInterval(this.충전시작루프)
        this.게임레벨++
        this.충전시작()
      }
    },

    충전시작() {
      this.충전시작루프 = setInterval(() => {

        let 랜덤번호 = Math.floor(Math.random() * this.오픈스페이스);
        let 랜덤칼라 = Math.floor(Math.random() * this.칼라.length);

        if (this.스페이스[랜덤번호].충전중 == false) {
          this.스페이스[랜덤번호].등록칼라 = 랜덤칼라

          if (this.스페이스[랜덤번호].충전중 == false) {
            this.스페이스[랜덤번호].충전중 = true
            this.충전(랜덤번호, 랜덤칼라)
          }
          else {
            this.충전중지(랜덤번호)
          }

        }
      }, this.게임난이도[this.게임레벨].등장속도)


    },

    충전(i, j) {
      let guage = document.getElementsByClassName('guage')[i]
      let guageLimit = document.getElementsByClassName('guage-limit')[i]

      //해당 스페이스의 게이지가 100이 되면 게임오버
      //그렇지 않으면 게이지가 색깔 속성의 충전속도에 맞춰 증가
      //하는 루프
      this.스페이스[i].충전중 = setInterval(() => {
        if (this.스페이스[i].게이지 == 100) {
          this.스페이스[i].게이지 = 100
          this.게임오버()
        }
        else {
          this.스페이스[i].게이지++
          guageLimit.style.height = this.칼라[j].요구게이지 + '%'
          guageLimit.style.borderTop = 'solid 2px ' + this.칼라[j].색깔
          guage.style.background = this.칼라[j].색깔
          guage.style.height = this.스페이스[i].게이지 + '%'
        }
      }, this.칼라[j].충전속도)
    },

    충전중지(i) {

      if (this.생명력 == 0) {
        this.게임오버()
      } else {
        clearInterval(this.스페이스[i].충전중)
        this.스페이스[i].충전중 = false

        let 등록칼라 = this.스페이스[i].등록칼라
        this.점수추가(i, 등록칼라)

        let 생명력게이지 = document.getElementsByClassName('life')[0]
        생명력게이지.style.width = this.생명력 + '%'

        if (this.생명력 < 30) {
          생명력게이지.style.background = 'red'
        } else {
          생명력게이지.style.background = '#0d6efd'
        }

        this.스페이스초기화(i)
        this.레벨업()
      }
    },

    스페이스초기화(i) {
      let guage = document.getElementsByClassName('guage')[i]
      let guageLimit = document.getElementsByClassName('guage-limit')[i]
      let 스페이스 = this.스페이스[i]

      스페이스.게이지 = 0
      스페이스.충전중 = false
      스페이스.등록칼라 = 0

      guage.style.height = '0%'
      guageLimit.style.borderTop = 'none'
    },

    점수추가(i, j) {
      let 게이지 = this.스페이스[i].게이지
      let 적정충전량 = Math.abs(게이지 - this.칼라[j].요구게이지)

      if (게이지 == 0) {
        this.스코어 += 0
      }
      else if (적정충전량 <= 3) {
        this.효과음()
        this.스코어 += this.칼라[j].점수
        this.스페이스[i].획득점수 = 'Perfect'
        if (this.생명력 > 95) {
          this.생명력 = 100
        } else {
          this.생명력 += 5
        }
        setTimeout(() => {
          this.스페이스[i].획득점수 = ''
        }, 1000);
      }
      else if (적정충전량 <= 8) {
        this.효과음()
        this.스코어 += this.칼라[j].점수 / 2
        this.스페이스[i].획득점수 = 'Good'
        if (this.생명력 == 100) {
          this.생명력 = 100
        } else {
          this.생명력 += 1
        }
        setTimeout(() => {
          this.스페이스[i].획득점수 = ''
        }, 1000);
      }
      else if (게이지 == 100) {
        this.배드효과음()
        this.스코어 -= 200
        this.스페이스[i].획득점수 = -200
        this.생명력 = 0
      }
      else {
        this.배드효과음()
        this.스코어 -= 50
        this.스페이스[i].획득점수 = 'Bad'
        this.배드체커++
        if (this.생명력 < 10) {
          this.생명력 = 0
        } else {
          this.생명력 -= 10
        }
        setTimeout(() => {
          this.스페이스[i].획득점수 = ''
        }, 1000);
      }
    },

    게임오버() {
      this.배드효과음()
      clearInterval(this.충전시작루프)

      for (let i = 0; i < 9; i++) {
        clearInterval(this.스페이스[i].충전중)
        this.스페이스[i].충전중 = false
        this.스페이스초기화(i)
      }
      this.게임시작전 = true
      this.결과창모달 = true

      this.끝시간 = Math.floor(new Date() / 1000)

      this.나의랭크순위 = this.랭크정보.filter(e => {
        return e.score > this.스코어
      }).length+1
    },

    ago(timeStamp) {
      var agoTime = Math.floor((Date.now() / 1000 - timeStamp.seconds))
      if (agoTime < 60) {
        return Math.floor((agoTime)) + '초'
      }
      else if (agoTime / 60 < 60) {
        return Math.floor((agoTime / 60)) + '분'
      }
      else if (agoTime / 60 / 60 < 24) {
        return Math.floor((agoTime / 60 / 60)) + '시간'
      }
      else {
        return Math.floor((agoTime / 60 / 60 / 24)) + '일'
      }
    },
  },


  mounted() {

    // 랭크(기록순)정보 불러오기
    db.collection('rank').orderBy('score', 'desc').onSnapshot((결과) => {
      this.랭크정보 = []
      let i = 1
      결과.forEach((doc) => {
        let obj = {...doc.data()}
        //DB 불러온 객체에 key+value 추가하려면 복사본에다가 담기
        obj.rank = i
        obj.id = doc.id
        console.log(obj)
        this.랭크정보.push(obj)
        i++
      })
      

      this.랭크정보2 = [...this.랭크정보].sort((a,b)=>{
        return b.date - a.date
      })
    })
    

    //누적 플레이
    db.collection('visit').onSnapshot((결과) => {
      결과.forEach((doc) => {
        this.플레이체크아이디 = doc.id
        //게임시작버튼 누를 때마다 visit의 정보가 갱신되어서 실시간 onSnapshot 작동
        //그러면서 바로 전체플레이수를 재랜더링 함
        this.전체플레이 = doc.data().all
        //가장 최근 도전이 얼마 전이었는지 저장
        this.최근도전 = this.ago(doc.data().date)
      })
    })
  },

  //닉네임 길이 검사
  watch: {
    닉네임(a, b) {
      if (a.length > 6) {
        this.닉네임 = b;
      }
    }
  },
}

</script>

<style scoped>
.captureArea {
  width: 340px;
  margin: auto;
}

.gameTitle {
  color: #0d6efd;
  font-weight: bold;
}

.rankList {
  margin: auto;
  width: 330px;
  position: relative;
}

.goTop {
  position: sticky;
  bottom: 0;
  width: 330px;
}

.space {
  position: relative;
  width: 330px;
  margin: auto;
  border: solid 2px black;
  animation: none;
}

.buttomModal {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.779);

  display: flex;
  align-items: center;
  justify-content: center;
}

.gameRule {
  position: absolute;
  top: 20%;
}

.gameRuleMore {
  color: #0d6efd;
}

.startBtn {
  position: absolute;
  bottom: 18%
}

.resultModal {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
}

.resultScore {
  font-size: 2rem;
}

.btn-close {
  position: absolute;
  right: 20px;
  top: 20px;
}

.inputBox {
  position: relative;
  margin-top: 20%;
}

.inputName {
  margin-bottom: 20px;
}

.bottomBlank{
  height: 5px;
}

.fakebar {
  position: absolute;
  top: 0;
  width: 330px;
  height: 40px;
  background: rgba(255, 255, 255, 0);
}

.table {
  width: 330px;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.lifeBox {
  position: relative;
  width: 330px;
  height: 20px;
  border: solid 2px black;
  border-bottom: none;
  margin: auto;
  animation: none;
}

.life {
  position: absolute;
  left: 0;
  height: 100%;
  width: 0%;
  background: #0d6efd;
  transition: all 0.5s;
}

.col-4 {
  position: relative;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guage-box {
  width: 110px;
  height: 110px;
  margin: auto;
  border: solid 1px;
  border-top: none;
  border-right: none;
  position: relative;

}

.guage-box:hover {
  border: solid 2px red;
}

.guage {
  width: 100%;
  height: 0%;
  background: red;
  position: absolute;
  bottom: 0;
}

.guage-limit {
  width: 100%;
  height: 0%;
  position: absolute;
  bottom: 0;
  border-top: none;
}

.point {
  position: absolute;
  color: black;
}

@keyframes warning {
  from {
    opacity: 0.5;
  }

  to {
    opacity: 1;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
